import { Component, OnInit }              from '@angular/core';
import { ModalController, NavController } from 'ionic-angular';
import { ItemSliding, Modal }             from 'ionic-angular';
import { Book, BookList }                 from "../../models/book";
import { MiscService }                    from "../../services/misc.service";
import { BookService }                    from "../../services/book.service";
import { CategoryService }                from "../../services/category.service";
import { AddBookComponent }               from '../add-book/add-book.component';
import { BookComponent }                  from '../book/book.component';

@Component({
  selector: 'dra-books',
  templateUrl: 'books.component.html',
})
export class BooksComponent implements OnInit {
  public books: Array<Book> = [];
  public categories: Array<any>;
  public categoriesMap = {0: {id: 0, name: 'All'}};
  public title: string = 'List';

  public isLoggedIn: boolean = true;
  public pages: number = 1;
  public searchParams: {
    search?: string,
    category_id?: number,
    bookmarked?: number,
    page?: number,
    per_page?: number,
    order_by?: string,
  } = {
    search: '',
    category_id: 0,
    bookmarked: 0,
    page: 1,
    per_page: 20,
    order_by: 'chapters_count'
  };
  public showSearch = {
    search: true,
    category_id: true,
    bookmarked: true,
    per_page: true,
    order_by: true,
  };
  public page = 'Books';

  public constructor(
    private modalController: ModalController,
    private navController: NavController,
    private bookService: BookService,
    private categoryService: CategoryService,
    private miscService: MiscService
  ) {
  }

  public async ngOnInit(): Promise<void> {
    console.log(window.location.search);
    this.miscService.stopLoading();

    this.getBooks();
    this.getCategories();
  }

  public goTo(page: string) {
    console.log(page);
    this.navController.setRoot(page);
  }

  public goBook($event: Event, book: Book) {
    console.log($event, book);
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }

    this.navController.push(BookComponent, {
      'bookAlias': book.alias
    });
  }

  public async setSearchParams(key: string, value?): Promise<void> {
    if (value !== undefined) this.searchParams[key] = value;
    await this.miscService.setUrlParams(key, this.searchParams[key]);
    await this.getBooks(true);
  }

  public async loadMore(infiniteScroll): Promise<void> {
    // console.log($event);
    this.searchParams.page++;
    await this.getBooks();
    infiniteScroll.complete();
  }

  public openAddBookModal(): void {
    let modal: Modal = this.modalController.create(AddBookComponent);
    modal.onDidDismiss((book?: Book) => book && this.goBook(null, book));

    modal.present();
  }

  public async getBooks(doSearch?: boolean, loader?): Promise<Book[]> {
    try {
      if (doSearch) this.searchParams.page = 1;

      this.miscService.startLoading();
      if (!this.searchParams.search || this.searchParams.search.length <= 0) this.searchParams.search = undefined;
      await this.miscService.setUrlParams('search', this.searchParams.search);

      let bookList: BookList = await this.bookService.getBooks(this.searchParams);
      this.miscService.stopLoading();
      if (loader) loader.complete();
      return this.processBooksData(bookList.books, bookList.pages, doSearch);

    } catch (error) {
      this.miscService.stopLoading();
      console.error(error);
    }
  }
  public async getCategories(): Promise<any> {
    try {
      let categoriesMap = await this.categoryService.getCategories();

      Object.assign(this.categoriesMap, categoriesMap);
      return this.categories = Object.keys(categoriesMap).map(index => categoriesMap[index]);

    } catch (error) {
      console.error(error);
    }
  }
  public async toggleBookmark(book: Book, slidingItem: ItemSliding): Promise<void> {
    try {
      console.log(slidingItem);
      await this.bookService.toggleBookmark(book);
      slidingItem.close();
    } catch (error) {
      console.log(error);
    }
  }

  private processBooksData(books: Book[], pages: number, refresh: boolean): Book[] {
    books.forEach(book => book.bookmarked = !!(book.bookmark && book.bookmark.status));

    this.books = (refresh || !this.books) ? books : this.books.concat(books);
    this.pages = pages;

    return this.books;
  }
}



// WEBPACK FOOTER //
// ./src/components/books/books.component.ts